import classNames from 'classnames';
import React from 'react';

import './Fieldset.scss';

type FieldsetProps = { legend?: string; legendClassName?: string } & React.PropsWithoutRef<
    JSX.IntrinsicElements['fieldset']
>;

const Fieldset: React.FC<FieldsetProps> = ({ className, legend, legendClassName, children, ...rest }) => (
    <fieldset className={classNames('fieldset-container', className)} {...rest}>
        {!!legend && <legend className={classNames('fieldset-container__legend', legendClassName)}>{legend}</legend>}
        {children}
    </fieldset>
);

export default Fieldset;
